// Approximate centroids, [longitude, latitude]. The panel map is deliberately
// coarse: state and country are the finest location it is ever given, so a
// centroid is the most precise point it can plot.

type LonLat = readonly [number, number];

/** ISO 3166-1 alpha-2, uppercase */
export const COUNTRY_CENTROIDS: Record<string, LonLat> = {
  AD: [1.6, 42.5], AE: [54.3, 23.9], AF: [66.0, 33.8], AL: [20.1, 41.1], AM: [44.9, 40.3],
  AO: [17.5, -12.3], AR: [-64.3, -35.4], AT: [14.1, 47.6], AU: [134.5, -25.7], AZ: [47.7, 40.3],
  BA: [17.8, 44.2], BD: [90.3, 23.8], BE: [4.6, 50.6], BF: [-1.7, 12.3], BG: [25.2, 42.8],
  BH: [50.5, 26.0], BJ: [2.3, 9.6], BN: [114.7, 4.5], BO: [-64.7, -16.7], BR: [-53.1, -10.8],
  BS: [-77.4, 25.0], BT: [90.4, 27.4], BW: [23.8, -22.2], BY: [28.0, 53.5], BZ: [-88.7, 17.2],
  CA: [-98.3, 57.6], CD: [23.6, -2.9], CF: [20.5, 6.6], CG: [15.2, -0.8], CH: [8.2, 46.8],
  CI: [-5.6, 7.6], CL: [-71.4, -37.7], CM: [12.7, 5.7], CN: [103.8, 36.6], CO: [-73.1, 3.9],
  CR: [-84.2, 9.98], CU: [-79.0, 21.6], CY: [33.0, 35.0], CZ: [15.3, 49.7], DE: [10.4, 51.1],
  DJ: [42.6, 11.7], DK: [10.0, 56.0], DO: [-70.5, 18.9], DZ: [2.6, 28.2], EC: [-78.8, -1.4],
  EE: [25.5, 58.7], EG: [29.9, 26.5], ER: [38.8, 15.4], ES: [-3.6, 40.2], ET: [39.6, 8.6],
  FI: [26.3, 64.5], FJ: [178.0, -17.8], FR: [2.5, 46.6], GA: [11.8, -0.6], GB: [-2.9, 54.1],
  GE: [43.5, 42.2], GH: [-1.2, 7.95], GL: [-41.3, 74.7], GM: [-15.4, 13.4], GN: [-10.9, 10.4],
  GQ: [10.3, 1.7], GR: [22.9, 39.1], GT: [-90.4, 15.7], GW: [-15.0, 12.0], GY: [-58.9, 4.8],
  HK: [114.1, 22.4], HN: [-86.6, 14.8], HR: [16.4, 45.1], HT: [-72.7, 18.9], HU: [19.4, 47.2],
  ID: [117.2, -2.2], IE: [-8.1, 53.2], IL: [35.0, 31.5], IN: [79.6, 22.9], IQ: [43.7, 33.0],
  IR: [54.3, 32.6], IS: [-18.6, 65.0], IT: [12.1, 42.8], JM: [-77.3, 18.2], JO: [36.8, 31.2],
  JP: [138.0, 37.6], KE: [37.8, 0.6], KG: [74.5, 41.5], KH: [104.9, 12.7], KP: [127.2, 40.2],
  KR: [127.8, 36.4], KW: [47.6, 29.3], KZ: [67.3, 48.2], LA: [103.7, 18.5], LB: [35.9, 33.9],
  LI: [9.5, 47.1], LK: [80.7, 7.6], LR: [-9.3, 6.5], LS: [28.2, -29.6], LT: [23.9, 55.3],
  LU: [6.1, 49.8], LV: [24.9, 56.9], LY: [18.0, 27.0], MA: [-6.3, 31.9], MC: [7.4, 43.7],
  MD: [28.5, 47.2], ME: [19.3, 42.8], MG: [46.7, -19.4], MK: [21.7, 41.6], ML: [-3.5, 17.3],
  MM: [96.5, 21.2], MN: [103.1, 46.8], MO: [113.5, 22.2], MR: [-10.3, 20.3], MT: [14.4, 35.9],
  MU: [57.6, -20.3], MW: [34.3, -13.2], MX: [-102.5, 23.9], MY: [109.7, 3.8], MZ: [35.5, -17.3],
  NA: [17.2, -22.1], NC: [165.7, -21.3], NE: [9.4, 17.4], NG: [8.1, 9.6], NI: [-85.0, 12.8],
  NL: [5.3, 52.1], NO: [15.3, 68.8], NP: [84.0, 28.2], NZ: [171.5, -41.8], OM: [56.1, 20.6],
  PA: [-80.1, 8.5], PE: [-74.4, -9.2], PG: [145.2, -6.5], PH: [122.9, 11.8], PK: [69.3, 29.9],
  PL: [19.4, 52.1], PR: [-66.5, 18.2], PT: [-8.5, 39.6], PY: [-58.4, -23.2], QA: [51.2, 25.3],
  RO: [25.0, 45.9], RS: [20.8, 44.2], RU: [96.7, 61.98], RW: [29.9, -2.0], SA: [44.5, 24.1],
  SD: [30.0, 16.0], SE: [16.7, 62.8], SG: [103.8, 1.35], SI: [14.8, 46.1], SK: [19.5, 48.7],
  SL: [-11.8, 8.6], SM: [12.5, 43.9], SN: [-14.5, 14.4], SO: [45.7, 4.8], SR: [-55.9, 4.1],
  SS: [30.2, 7.3], SV: [-88.9, 13.7], SY: [38.5, 35.0], SZ: [31.5, -26.6], TD: [18.6, 15.3],
  TG: [0.96, 8.5], TH: [101.0, 15.1], TJ: [71.0, 38.5], TL: [125.8, -8.8], TM: [59.4, 39.1],
  TN: [9.6, 34.1], TR: [35.2, 39.1], TT: [-61.3, 10.5], TW: [120.95, 23.75], TZ: [34.8, -6.3],
  UA: [31.4, 49.0], UG: [32.4, 1.3], US: [-98.6, 39.8], UY: [-56.0, -32.8], UZ: [63.1, 41.8],
  VE: [-66.2, 7.1], VN: [106.3, 16.6], YE: [47.6, 15.9], ZA: [25.1, -29.0], ZM: [27.8, -13.5],
  ZW: [29.9, -19.0],
};

/** Keyed `${country}-${stateCode}`. Only countries wide enough for a state to matter. */
const STATE_CENTROIDS: Record<string, LonLat> = {
  'US-AL': [-86.8, 32.8], 'US-AK': [-152.4, 64.0], 'US-AZ': [-111.7, 34.2], 'US-AR': [-92.4, 34.9],
  'US-CA': [-119.4, 37.2], 'US-CO': [-105.5, 39.0], 'US-CT': [-72.7, 41.6], 'US-DE': [-75.5, 39.0],
  'US-DC': [-77.0, 38.9], 'US-FL': [-81.7, 28.1], 'US-GA': [-83.4, 32.7], 'US-HI': [-157.5, 20.8],
  'US-ID': [-114.5, 44.2], 'US-IL': [-89.2, 40.0], 'US-IN': [-86.3, 39.9], 'US-IA': [-93.5, 42.1],
  'US-KS': [-98.4, 38.5], 'US-KY': [-84.9, 37.5], 'US-LA': [-91.9, 31.1], 'US-ME': [-69.2, 45.3],
  'US-MD': [-76.8, 39.0], 'US-MA': [-71.8, 42.3], 'US-MI': [-84.6, 43.3], 'US-MN': [-94.3, 46.3],
  'US-MS': [-89.7, 32.7], 'US-MO': [-92.5, 38.4], 'US-MT': [-109.6, 47.0], 'US-NE': [-99.8, 41.5],
  'US-NV': [-116.6, 39.3], 'US-NH': [-71.6, 43.7], 'US-NJ': [-74.7, 40.2], 'US-NM': [-106.1, 34.4],
  'US-NY': [-75.5, 42.9], 'US-NC': [-79.4, 35.6], 'US-ND': [-100.5, 47.5], 'US-OH': [-82.8, 40.3],
  'US-OK': [-97.5, 35.6], 'US-OR': [-120.6, 43.9], 'US-PA': [-77.8, 40.9], 'US-RI': [-71.5, 41.7],
  'US-SC': [-80.9, 33.9], 'US-SD': [-100.2, 44.4], 'US-TN': [-86.3, 35.9], 'US-TX': [-99.3, 31.5],
  'US-UT': [-111.7, 39.3], 'US-VT': [-72.7, 44.1], 'US-VA': [-78.8, 37.5], 'US-WA': [-120.4, 47.4],
  'US-WV': [-80.6, 38.6], 'US-WI': [-89.9, 44.6], 'US-WY': [-107.6, 43.0], 'US-PR': [-66.5, 18.2],
  'CA-AB': [-114.5, 55.0], 'CA-BC': [-125.0, 54.5], 'CA-MB': [-97.8, 55.0], 'CA-NB': [-66.4, 46.6],
  'CA-NL': [-60.0, 53.0], 'CA-NS': [-63.3, 45.2], 'CA-NT': [-119.0, 64.3], 'CA-NU': [-92.0, 68.0],
  'CA-ON': [-85.0, 50.0], 'CA-PE': [-63.2, 46.3], 'CA-QC': [-72.0, 52.0], 'CA-SK': [-106.0, 54.5],
  'CA-YT': [-135.5, 63.6],
  'AU-NSW': [146.9, -32.2], 'AU-VIC': [144.3, -36.9], 'AU-QLD': [144.5, -22.6], 'AU-WA': [122.2, -25.3],
  'AU-SA': [135.8, -30.1], 'AU-TAS': [146.6, -42.0], 'AU-NT': [133.4, -19.4], 'AU-ACT': [149.0, -35.5],
};

export interface RegionLike {
  state: string | null;
  country: string | null;
}

/** Stable key for grouping rows that land on the same point. Null when the region cannot be placed. */
export const regionKey = (region: RegionLike | null | undefined): string | null => {
  const country = region?.country?.trim().toUpperCase();
  if (!country || !COUNTRY_CENTROIDS[country]) return null;
  const state = region?.state?.trim().toUpperCase();
  return state && STATE_CENTROIDS[`${country}-${state}`] ? `${country}-${state}` : country;
};

/**
 * Region to [longitude, latitude], for the map's d3 projection to place. An
 * unknown or null state falls back to the country centroid; an unknown or null
 * country returns null and the caller counts the row as unplaced rather than
 * guessing.
 */
export const regionLonLat = (region: RegionLike | null | undefined): [number, number] | null => {
  const key = regionKey(region);
  if (!key) return null;
  const [lon, lat] = STATE_CENTROIDS[key] ?? COUNTRY_CENTROIDS[key];
  return [lon, lat];
};
